<style scoped>
  .wrapper {
    display: flex;
    height: calc(100% - 60px);
    min-height: 74vh;
    margin-top:85px;
    width: 100%;
    overflow: hidden;
  }
  .items-center {
    align-items: center;
  }
</style>

<style>
  .o > .tel-input-template > .ivu-row > .ivu-col > .ivu-input-wrapper > .ivu-input-group-prepend > .ivu-dropdown > .ivu-select-dropdown > .ivu-dropdown-menu {
    max-height: 125px !important;
  }
</style>


<template>
  <div class="flex-container" style="align-items:flex-start;margin-top:85px;">

    <!-- start - forgot -->
    <div v-show="currentStep=='forgot' || currentStep=='resend'"
         style="height:auto; width:100%;">
      <Row :gutter="16">
        <Col span="22" push="1" pull="1">
          <Card dis-hover :bordered="false" style="text-align:center;background-color:transparent !important;">
            <img alt=" " src="@/assets/forgot-password.png">
            <br>
            <h2>{{ (currentStep=='forgot')? 'Forgot Password': 'Resend SMS' }} </h2>
            
            <p v-if="currentStep=='forgot' && via=='email'">Enter your email address and we'll email you a link to reset your password.</p>
            <p v-else-if="currentStep=='forgot' && via=='mobile'">Enter your registered mobile number and we'll send you an SMS with a link to reset your password.</p>
            <p v-else-if="currentStep=='resend' && via=='email'">If you haven't received your activiation email, enter your email below and we'll send you another.</p>
            <p v-else-if="currentStep=='resend' && via=='mobile'">If you haven't received your SMS, enter your registered mobile number below and we'll send you another.</p>

            <br>
            <RadioGroup v-model="via">
              <Radio label="email">
                  <span>Email</span>
              </Radio>
              <Radio label="mobile" val>
                  <span>Mobile</span>
              </Radio>
           </RadioGroup>
           <br /><br />
            <Row v-show="via=='email'">
              <Input type="email" :spellcheck="false" autocomplete="off" autofocus v-model="email" size="large" icon="ios-email-outline" placeholder="Email" style="margin-bottom:10px;width:100%;"></Input>              
            </Row>
            <Row v-show="via=='mobile'" type="flex" :gutter="20" class="o">
              <i-col span="24" style="margin-bottom:10px" class="o">
                <tel-input-lg v-model="mobile" @onTelInput="onTelInput" ref="telInput"></tel-input-lg>
              </i-col>
            </Row>

            <Row>
              <Button :disabled="isSending || invalid" :loading="isSending"  @click="(!isSending && via=='mobile') ? sendViaMobile(): sendViaEmail()" type="primary" style="width:100%;">
                {{ currentStep=='forgot'? 'Send': 'Resend' }}
              </Button>
            </Row>
            <br>
            <Row v-if="currentStep=='forgot'">
              <a @click="$router.push({path:'/login?type=signin'})">Wait, I remember it</a>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
    <!-- end - forgot -->

    <!-- start - emailed -->
    <div v-show="currentStep=='emailed'" style="height:auto; width:100%;">
      <Row :gutter="16">
        <Col span="22" push="1" pull="1">
          <Card dis-hover :bordered="false" style="text-align:center;background-color:transparent !important;">
            <img alt=" " src="@/assets/emailed.png">
            <br>

            <h2 v-if="via=='email'">We just emailed you</h2>
            <h2 v-else-if="via=='mobile'">SMS have been sent</h2>

            <p v-if="via=='email'">Password reset instructions have been emailed to {{email}}. If you didn't receive an email, please check your spam folder.</p>
            <p v-else-if="via=='mobile'">Password reset instructions have been sent to {{mobile}}. If you didn't receive an SMS, try to <a @click="currentStep='resend'">resend</a>. </p>

            <br>
            <Row v-if="via=='email'">
              <a @click="currentStep='resend'"><u>Haven't received your email?</u></a>
            </Row>
          </Card>      
        </Col>
      </Row>
    </div>    
    <!-- end - emailed -->

    <!-- start - reset -->
    <div v-show="currentStep=='reset'" style="height:auto; width:100%;">
      <Row :gutter="16">
        <Col span="22" push="1" pull="1">
          <Card dis-hover :bordered="false" style="text-align:center;background-color:transparent !important;">
            <img alt=" " src="@/assets/forgot-password.png">
            <br>
            <h2>Reset your password</h2>
            <p>Enter your password twice.</p>    
            <br>
            <Row>
              <!-- @on-click="disableNewPassword=!disableNewPassword" -->
              <Input placeholder="New password" style="width:100%;"
                    v-model="newPassword"     
                    :spellcheck="false" 
                    autocomplete="off"               
                    @on-click="disableNewPassword=!disableNewPassword"
                    :type="disableNewPassword? 'text':'password'"
                    :icon="disableNewPassword? 'eye-disabled':'eye'" ></Input>
            </Row>
            <Row style="margin-top:5px;">
              <!-- @on-click="disableNewPasswordRe=!disableNewPasswordRe" -->
              <Input placeholder="Retype new password" style="width:100%;"
                    v-model="newPasswordRe"               
                    :spellcheck="false" 
                    autocomplete="off"  
                    @on-click="disableNewPasswordRe=!disableNewPasswordRe"
                    :type="disableNewPasswordRe? 'text':'password'"
                    :icon="disableNewPasswordRe? 'eye-disabled':'eye'"></Input>
            </Row>
            <br>
            <Row>
              <Button v-if="isResetting" :disabled="true" type="primary" style="width:100%;" :loading="true"></Button>
              <Button v-else @click="reset()" :disabled="passwordMisMatch" type="primary" style="width:100%;">Reset</Button>
            </Row>            
          </Card>      
        </Col>
      </Row>
    </div>    
    <!-- end - reset -->

  </div>
</template>


<script>
import Utils from '@/utils.js';
import BeFirst from '@/components/BeFirstToComponent';
import { TelInputLg } from '@/helpers/tel-input';

export default {
  name: 'ForgotPasswordComponent',
  components: { BeFirst, TelInputLg },
  props: {
    step: {
      type: String,
      required: true,
      default: 'forgot'
    },
    block: {
      type: String,
      required: true,
      default: 'page'
    }
  },
  data() {
    return {
      via: 'mobile',
      isResetting: false,
      isSending: false,
      email:'',
      mobile: '',
      newPassword: '',
      newPasswordRe: '',
      currentStep:this.step,
      invalid: true,
      passwordMisMatch: true,
      disableNewPassword: false,
      disableNewPasswordRe: false
    }
  },
  watch: {
    via(v) {
      if (v == "email") {
        if (this.email!=undefined) {
          this.invalid=!Utils.validateEmail(this.email);
        }
      }
      else {
        this.invalid=this.$refs.telInput.state==false;
      }
    },
    "email": function() {
      this.invalid=true;
      if (this.email!=undefined) {
        this.invalid=!Utils.validateEmail(this.email);
      }
    },
    "newPassword": function() {
      this.passwordMisMatch=true;      
      if (this.newPassword!=undefined && this.newPasswordRe!=undefined && (this.newPassword.length>0 && this.newPasswordRe.length>0)) {
        this.passwordMisMatch = !(this.newPassword==this.newPasswordRe) ;
      }
    },
    "newPasswordRe": function() {
      this.passwordMisMatch=true;
      if (this.newPassword!=undefined && this.newPasswordRe!=undefined && (this.newPassword.length>0 && this.newPasswordRe.length>0)) {
        this.passwordMisMatch = !(this.newPassword==this.newPasswordRe);
      }
    }
  },
  // computed: {
  //   defaultEmail: function() {
  //     return this.$store.state.user.info.user_email;
  //   }
  // },
  mounted() {
    setTimeout( () => {
      this.email = "";
      this.mobile = "";
      this.$refs.telInput.resetNum()
    }, 500)
  },
  methods: {
    onTelInput(res) {
      this.invalid=res.isValid==false;
      this.tempNumber = (res.isValid) ? res.number: null;
    },    
    showPassword: function() {
      this.disableNewPassword=!this.disableNewPassword;
    },
    showPasswordRe: function() {
      this.disableNewPasswordRe=!this.disableNewPasswordRe;
    },
    sendViaMobile: function() {
      console.log("sendViaMobile...");
      this.isSending=true;
      this.$store.dispatch('user/forgotPasswordViaMobile', this.mobile).then(
        res=> {
          console.log('return res.', res);
          this.isSending=false;
          this.currentStep='emailed';
        },
        error => {
          this.isSending=false;
          console.log('error...', error.response.data);
          if (error.response) {
            if (error.response.data.error.code == 404) {
              this.isSending=false;
          this.currentStep='emailed';
            }
            else {
              this.$Message({
                closable: true,
                title: { content:'Error!' },
                icon: 'ios-close',
                message: { content: error.response.data.error.message },
                buttons: [
                  { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> {} }
                ]
              });   
            }                   
          }
        }
      );
    },    
    sendViaEmail: function() {
      this.isSending=true;
      this.$store.dispatch('user/forgotPasswordViaEmail',this.email).then(
        res=> {
          this.isSending=false;
          this.currentStep='emailed';
        },
        error => {
          this.isSending=false;
          if (error.response) {
            if (error.response.data.error.code == 404) {
              this.isSending=false;
              this.currentStep='emailed';
            }
            else {
              this.$Message({
                closable: true,
                title: { content:'Error!' },
                icon: 'ios-trash',
                message: { content:  error.response.data.error.message },
                buttons: [
                  { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> {} }
                ]
              });
            }                      
          }
        }
      );
    },
    reset: function() {      
      var param = { 
        key: this.$route.query.key, 
        user_id: this.$route.query.user_id, 
        new_password: this.newPassword
      };
      this.isResetting=true;
      this.$store.dispatch('user/resetPassword', param).then(
        res => {
          this.isResetting=false;

          this.$Message({
            closable: true,
            title: { content:'Changed!' },
            icon: 'checkmark',
            message: { content: 'Your password has been changed.' },
            buttons: [
              { label: 'Ok', type: 'success', hideAfter:true, action: ()=> {} }
            ]
          });              
          this.$router.replace('/login')
        },
        error => {
          this.isResetting=false;
            this.$Message({
              closable: true,
              title: { content:'Error!' },
              icon: 'ios-close',
              message: { content: error.response.data.error.message },
              buttons: [
                { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> {} }
              ]
            });                              
        }
      );
    }
  }
}

</script>
